export const updatedChannelEvent = 'channelTagUpdated';
export const disableStatusUpdated = 'disableStatusUpdated';
export const flashingStatusUpdated = 'flashingStatusUpdated';
export const updateToggleState = 'updateToggleState';
export const openChannelEvent = 'openChannelUpdated';
export const closeChannelEvent = 'closeChannelUpdated';
export const flashChannelEvent = 'flashChannelUpdated';
export const updateValueEventName = 'valueUpdated';
export const click = 'click';
export const visualStateEvent = 'visualStateUpdated';

export function addHandler(elem: Element, eventName: string, handler: EventListener) {
    let map = handlers.get(elem);
    if (!map) {
        map = new Map<string, EventListener>();
        handlers.set(elem, map);
    }
    const prev = map.get(eventName);
    if (prev) elem.removeEventListener(eventName, prev);

    map.set(eventName, handler);
    elem.addEventListener(eventName, handler);
}

export const handlers = new Map<Element, Map<string, EventListener>>();

export function clearOneHandler(elem: Element) {
    handlers.delete(elem);
}

export function clearHandlers(): void {
    handlers.forEach((map, elem) => {
        for (const [evt, handler] of map) {
            elem.removeEventListener(evt, handler);
        }
    });
    handlers.clear();
}
